import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useResourceContext } from 'react-admin';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { Merchant } from 'types/embedded/merchant';

import { StyledBox } from './CreatedSuccessDialog.styled';

type CreatedSuccessDialogProps = { merchant: Merchant };

export const CreatedSuccessDialog: React.FC<CreatedSuccessDialogProps> = ({ merchant }) => {
  const navigate = useNavigate();
  const onClose = () => navigate(-1);
  const resource = useResourceContext();
  const { createPathWithQuery } = useCreatePathWithQuery();

  const to = createPathWithQuery({
    resource,
    id: merchant.id,
    type: 'show',
  });

  return (
    <Dialog onClose={() => navigate(-1)} open={!!merchant} width="640px">
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Мерчант создан"
          titleSize="smallBold"
        />
        <Typography sx={{ padding: '24px 24px 0' }} variant="body1">
          Мерчант <TypographyBold fontSize={16} text={merchant.name} /> создан вы можете перейти к
          настройке мерчанта.
        </Typography>
        <CardActionsButtons
          rightActionsSlot={
            <Button component={Link} label="Перейти к настройке" to={to} variant="outlined" />
          }
        />
      </StyledBox>
    </Dialog>
  );
};
